export const FOIL_EFFECTS = 'FOIL_EFFECTS';
export const ADDITIONAL_RENDER = 'ADDITIONAL_RENDER';
export const BPC_COLOR_CODE2_RENDER = 'BPC_COLOR_CODE2_RENDER';
export const BP_OPTION_LAYERS = 'BP_OPTION_LAYERS';
/* 기능 : 옵션 선택에 따라 만들기툴에 추가 레이어를 만들어줘서 옵션에 해당되는 이미지를 만들기툴에서 표현 가능*/
